/**
 * Translation texts for TimeSlots components
 *
 * Provides translation keys for time period headers and time ranges.
 * Uses the Schedule_TimeSlots category for consistency with existing translations.
 *
 * Requirements: 10.1, 10.2, 10.3, 10.4
 */

export default (getText: (key: string, category: string) => string) => (key: string) =>
  ({
    // Time period titles
    mornings: getText('Mornings', 'Schedule_TimeSlots'),
    afternoons: getText('Afternoons', 'Schedule_TimeSlots'),
    evenings: getText('Evenings', 'Schedule_TimeSlots'),
    
    // Time range descriptions
    morningTimeRange: getText('00:00 AM to 12:00 PM', 'Schedule_TimeSlots'),
    afternoonTimeRange: getText('12:00 PM to 6:00 PM', 'Schedule_TimeSlots'),
    eveningTimeRange: getText('6:00 PM to 12:00 AM', 'Schedule_TimeSlots'),
  }[key])
